import type { IntlFormatOptions } from './types';

export const DEFAULT_TIMEZONE = 'UTC';
export const DEFAULT_LANGUAGE = 'en_US';
export const ISO_8601_FORMAT = "yyyy-MM-dd'T'HH:mm:ss";
export const FULL_ISO_8601_FORMAT = "yyyy-MM-dd'T'HH:mm:ss'Z'";
export const ISO_8601_DATE_FORMAT = 'yyyy-MM-dd';
export const DEFAULT_TIME_FORMAT = 'h:mm a';
export const TIME_FORMAT_24HS = 'HH:mm';
export const ALTERNATIVE_TIME_FORMAT = 'h:mma';
export const FULL_TIME_FORMAT = 'HH:mm:ss';
export const LONG_MONTH_DATE = 'MMM d';
export const ISO_8601_SET = [ISO_8601_FORMAT, FULL_ISO_8601_FORMAT];
export const TIME_FORMAT_SET = [
    FULL_TIME_FORMAT,
    ALTERNATIVE_TIME_FORMAT,
    DEFAULT_TIME_FORMAT,
    TIME_FORMAT_24HS,
];

// intlFormat constants
export const DATE_FNS_FORMAT_CONFIG: IntlFormatOptions = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
};

export const FULL_DATE_FORMAT: IntlFormatOptions = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
};

export const FULL_DATE_WEEK_DAY_FORMAT: IntlFormatOptions = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
};

export const NUMERAL_DATE_FORMAT: IntlFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
};
